<template>
    <div class="nav-content">
        <div class="promote-pc-box" style="position: relative;" >
            <div style="position: absolute; top:-3px; right:3px; font-size: 1.5rem; ">
                <!-- <a @click="closePromote" style="color:#3DB4F1;">X</a> -->
                <img style="width: 15px;cursor: pointer;" src="../assets/images/close.png"  @click="closePromote">
            </div>
            <div style="height: 700px; overflow-y: scroll;">
                <!-- <div class="site-tab">
                    <button  v-for="(item,index) in siteList" :key="index" @click="handleTabs(item)" >
                        <span v-show="activeTab == item" style="color: #888">{{ item == 'JD'?  '京东' : '淘宝' }}</span>
                        <span v-show="activeTab != item" style="color: #CCC">{{ item == 'JD'?  '京东' : '淘宝' }}</span>
                    </button>
                </div> -->
                <div style="color:#F56352;font-size: 1.3rem;text-align: center;padding: 20px 0 20px 0;border-bottom: 2px solid #F56352; margin-bottom: 20px;">
                    天猫
                </div>
                <div style="display: flex; flex-wrap: wrap; width: 100%; gap: 20px;">
                    <div class="jd" v-for="(jitem, jindex) in tb" v-bind:key="jindex" :id="'jd-' + jindex" >
                        <div style="width:210px">
                            <a :href="jitem.coupon_url ?  jitem.coupon_url : jitem.promote_url" :title="jitem.name" target="_blank">
                                <img :src="'https://' + jitem.img" width="210">
                                <p style="font-size: 1rem;">{{jitem.name.length > 40 ? jitem.name.substring(0, 40) + '...' : jitem.name}}</p>
                                <p style="font-size: 1rem;">
                                    <span style="color:#3DB4F1;font-weight: bold;">{{jitem.price}} 元 </span>
                                    <span style="color:#AAA;font-size: 0.8rem;">销量: {{jitem.sales}}</span>
                                </p>
                            </a>
                        </div>
                    </div>
                </div>
                <div style="color:#F56352;font-size: 1.3rem;text-align: center;padding: 20px 0 20px 0;border-bottom: 2px solid #F56352; margin-bottom: 20px;">
                    京东
                </div>
                <div style="display: flex; flex-wrap: wrap; width: 100%; gap: 20px;">
                    <div class="jd" v-for="(jitem, jindex) in jd" v-bind:key="jindex" :id="'jd-' + jindex" >
                        <div style="width:210px">
                            <a :href="jitem.coupon_url ?  jitem.coupon_url : jitem.promote_url" :title="jitem.name" target="_blank">
                                <img :src="'https://' + jitem.img" width="210">
                                <p style="font-size: 1rem;">{{jitem.name.length > 40 ? jitem.name.substring(0, 40) + '...' : jitem.name}}</p>
                                <p style="font-size: 1rem;">
                                    <span style="color:#3DB4F1;font-weight: bold;">{{jitem.price}} 元 </span>
                                    <span style="color:#AAA;font-size: 0.8rem;">销量: {{jitem.sales}}</span>
                                </p>
                            </a>
                        </div>
                    </div>
                </div>
                <div v-show="activeTab === 'Taobao'">
                    Taobao
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
    export default {
        name: 'promote',
        data: function () {
            return {
                jd: [],
                tb: [],
                // siteList: ['JD'], 
                // activeTab: 'JD',
                // pageSize: 12,
            }
        },
        created: function () {
            var that = this
            this.$http.get(`https://www.anyknew.com/static/promote/jd.json?random=${Math.random()}`, {}, function (r) {
                if (r) {
                    // 计算处理分类数据
                    that.jd = r.jd;

                    // that.jdPageNum = Math.ceil(r.jd.length / that.pageSize) || 1
                    // for(let i=0; i < that.jdPageNum; i++){
                    //     that.jdPages[i] = r.jd.slice(that.pageSize * i, that.pageSize*(i+1))
                    // }
                    // that.activePage = that.jdPages[that.activePageNum]
                }
            })
            this.$http.get(`https://www.anyknew.com/static/promote/tb.json?random=${Math.random()}`, {}, function (r) {
                if (r) {
                    // 计算处理分类数据
                    that.tb = r.tb;

                    // that.jdPageNum = Math.ceil(r.jd.length / that.pageSize) || 1
                    // for(let i=0; i < that.jdPageNum; i++){
                    //     that.jdPages[i] = r.jd.slice(that.pageSize * i, that.pageSize*(i+1))
                    // }
                    // that.activePage = that.jdPages[that.activePageNum]
                }
            })
        },
        methods: {
            // tab切换
            closePromote(){
                this.$emit("closePromoteModal");
            },
            handleTabs(tab) {
                this.activeTab = tab
            },
            // nextPage() {
            //     if(activeTab == 'JD'){
            //         this.activePage = this.jdPages[++this.activePageNum]
            //     }
            // },
            // prePage() {
            //     if(activeTab == 'JD'){
            //         if(this.activePageNum == 0) return
            //         this.activePage = this.jdPages[--this.activePageNum]
            //     }
            // }
        }
    }
</script>

<style lang="less">
    ::-webkit-scrollbar {
        width: 5px;
    }
    ::-webkit-scrollbar-track {
        background: transparent;
    }
    ::-webkit-scrollbar-thumb {
        background-color: rgba(155, 155, 155, 0.5);
        border-radius: 20px;
        border: transparent;
    }
    .promote-pc-box{
        margin: auto;
        margin-top: 50px;
        width: 960px;
        border-radius: 5px;
        background-color: #FFFFFF;
        padding: 0px 20px 10px 20px;
        .site-tab{
            // overflow: hidden;
            // border: 1px solid #ccc;
            // background-color: #f1f1f1;
            display: flex;
            gap: 20px;
            flex-wrap: wrap;
            // justify-content: center;
            border-bottom: 2px solid #EEE;
            margin-bottom: 10px;
            button {
                // background-color: inherit;
                display: inline;
                color: #3DB4F1 ;
                float: left;
                border: none;
                outline: none;
                cursor: pointer;
                padding: 10px 20px 5px 0px;
                transition: 0.3s;
                font-size: 1.5rem;
            }
        }
        &.mobile{
            width: 90%;
            margin-top: 35px;
            padding: 10px;
        }
        .img-box{
            text-align: center;
        }
        .switch-method{
            margin-top: 5px;
            text-align: center;
            font-size: 1rem;
            color: #3DB4F1;
        }
        .info-box{
            margin-top: 10px;
            text-align: center;
            color: #666666;
            font-size: 1rem;
            line-height: 1.5rem;
            p{margin: 5px auto}
            a{
                color: #3DB4F1;
            }
        }
    }

</style>
